var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLength1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M7.591 12.492v1.758H6.75v-4.5h1.379q.462 0 .791.096.332.094.54.265a1 1 0 0 1 .31.41q.1.238.1.524a1.33 1.33 0 0 1-.262.796q-.126.165-.313.29-.184.125-.422.199a.8.8 0 0 1 .275.258l1.132 1.662h-.757a.4.4 0 0 1-.187-.044.4.4 0 0 1-.128-.124l-.95-1.44a.33.33 0 0 0-.12-.116.4.4 0 0 0-.187-.034zm0-.6h.525q.238 0 .413-.06a.8.8 0 0 0 .29-.162.66.66 0 0 0 .173-.249.9.9 0 0 0 .056-.314q0-.343-.228-.526-.225-.183-.691-.184H7.59v1.494Zm6.08-2.142v.666h-2.004v1.248h1.579v.644h-1.579v1.273h2.004v.669H10.82v-4.5zm3.579 0v.666h-2.004v1.332h1.691v.669h-1.691v1.833h-.848v-4.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLength1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/length-1.02c9db99.svg";